import { Inject, Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { StaffEmployee } from "../../../domain/models/employment/employee.model";
import { SessionCtl } from "../../../infra/services/session.ctl.service";
import { StaffEmployeesPort } from "../../ports/employment/staff-employees.port";
import { STAFF_EMPLOYEES_PORT } from "../../ports/employment/staff-employees.token";

@Injectable({ providedIn: "root" })
export class ResolveCurrentStaffEmployeeUseCase {
  constructor(
    private readonly session: SessionCtl,
    @Inject(STAFF_EMPLOYEES_PORT)
    private readonly employees: StaffEmployeesPort,
  ) {}

  execute(): Observable<StaffEmployee> {
    const employeeId = this.session.getEmployeeId();
    if (employeeId) return this.employees.getById(employeeId);

    return throwError(
      () =>
        new Error(
          "Tu cuenta todavía no está vinculada a Employee. Comunícate con RR. HH.",
        ),
    );
  }
}
